<template>
  <div
    class="tt-select-dropdown"
    v-bind="$attrs"
    :class="className"
    :style="styles"
  >
    <slot />
  </div>
</template>
<script>
import { createPopper } from '@popperjs/core'

let transferIndex = 0
export default {
  name: 'Drop',
  props: {
    placement: {
      type: String,
      default: 'bottom-start'
    },
    className: {
      type: String
    },
    transfer: {
      type: Boolean
    }
  },
  data() {
    return {
      popper: null,
      width: '',
      popperStatus: false,
      tIndex: this.handleGetIndex()
    }
  },
  computed: {
    styles() {
      const style = {}
      if (this.width) style.minWidth = `${this.width}px`

      if (this.transfer) style['z-index'] = 1060 + this.tIndex

      return style
    }
  },
  methods: {
    update() {
      if (this.popper) {
        this.$nextTick(() => {
          this.updatePopper()
          this.popperStatus = true
        })
      } else {
        this.$nextTick(() => {
          this.popper = createPopper(this.$parent.$refs.reference, this.$el, {
            placement: this.placement,
            modifiers: [
              {
                name: 'preventOverflow',
                options: {
                  boundary: 'document.body'
                }
              },
              {
                name: 'computeStyles',
                options: {
                  gpuAcceleration: false // true by default
                }
              }
            ],
            onCreate: () => {
              this.resetTransformOrigin()
              this.$nextTick(this.updatePopper)
            },
            onUpdate: () => {
              this.resetTransformOrigin()
            }
          })
          this.$emit('create', this.popper)
        })
      }
      this.tIndex = this.handleGetIndex()
    },
    destroy() {
      if (this.popper) {
        setTimeout(() => {
          if (this.popper && !this.popperStatus) {
            this.popper.destroy()
            this.popper = null
          }
          this.popperStatus = false
        }, 300)
      }
    },
    resetTransformOrigin() {
      if (!this.popper) return

      const x_placement = this.popper.popper.getAttribute('x-placement')
      const placementStart = x_placement.split('-')[0]
      const placementEnd = x_placement.split('-')[1]
      const leftOrRight = x_placement === 'left' || x_placement === 'right'
      if (!leftOrRight) {
        this.popper.popper.style.transformOrigin =
          placementStart === 'bottom' ||
          (placementStart !== 'top' && placementEnd === 'start')
            ? 'center top'
            : 'center bottom'
      }
    },
    updatePopper() {
      this.popper && this.popper.update()
      this.$emit('update', this.popper)
    },
    handleGetIndex() {
      transferIndex++
      return transferIndex
    }
  },
  created() {
    this.update()
    this.$on('on-update-popper', this.update)
    this.$on('on-destroy-popper', this.destroy)
  },
  beforeDestroy() {
    if (this.popper) {
      this.popper.destroy()
    }
  }
}
</script>
<style lang="less">
.tt-select-dropdown {
  width: inherit;
  box-sizing: border-box;
  border-radius: 2px;
  position: absolute;
  z-index: 1040;
  transform-origin: center top;
  &-transfer {
    z-index: 1060;
    width: auto;
  }
}
</style>
